<template>
    <form validate @submit.stop.prevent="submit">
        <md-input-container :class="{'md-input-invalid': currentPasswordError()}">
            <label>Current Password</label>
            <md-input v-model="currentPassword" type="password" required></md-input>
            <span class="md-error" v-if="currentPasswordError">{{errorMessage}}</span>
        </md-input-container >
        <md-input-container :class="{'md-input-invalid': newPasswordError()}">
            <label>New Password</label>
            <md-input v-model="newPassword" type="password" required></md-input>
            <span class="md-error" v-if="newPasswordError">{{errorMessage}}</span>
        </md-input-container>
        <md-input-container :class="{'md-input-invalid': confirmPasswordError()}">
            <label>Re-Type Password</label>
            <md-input v-model="confirmPassword" type="password" required></md-input>
            <span class="md-error" v-if="confirmPasswordError">Passwords do not match</span>
        </md-input-container>
        <md-button class="md-raised" @click="submit">Submit</md-button>
    </form>
</template>

<script>
import firebase from 'firebase';
import { mapGetters } from 'vuex';

const ChangePassword = {
    name: 'change-password',
    data: function() {
        return {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            hasError: '',
            errorMessage: ''
        };
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    methods: {
        submit() {
            // const self = this;
            this.hasError = '';
            this.errorMessage = '';

            const currentUser = firebase.auth().currentUser;
            const credential = firebase.auth.EmailAuthProvider.credential(this.user.email, this.currentPassword);
            currentUser.reauthenticateWithCredential(credential).then(() => {
                currentUser.updatePassword(this.newPassword).then(() => {
                    this.currentPassword = '';
                    this.newPassword = '';
                    this.confirmPassword = '';
                    this.hasError = '';
                    this.errorMessage = '';
                }).catch((error) => {
                    this.hasError = error.code;
                    this.errorMessage = error.message;
                });
            }).catch((error) => {
                this.hasError = error.code;
                this.errorMessage = error.message;
            });

            // this.hasError = '';
            // this.errorMessage = '';
            // const currentUser = firebase.auth().currentUser;
            // console.log(currentUser);
            // // if (currentUser.provider)
            // firebase.auth().createUserWithEmailAndPassword(this.newUser.email, this.newUser.password)
            // .then((user) => {
            //     user.updateProfile({
            //         displayName: `${this.newUser.firstName} ${this.newUser.lastName}`
            //     }).then(() => {
            //         console.log(user);
            //         self.$emit('success', user);
            //     });
            // }).catch((error) => {
            //     // Handle Errors here.
            //     console.log(error.code);
            //     this.hasError = error.code;
            //     this.errorMessage = error.message;
            // });
        },
        isComplete() {
            return !this.confirmPasswordError() && this.currentPassword !== '' && this.newPassword !== '' && this.confirmPassword !== '';
        },
        currentPasswordError() {
            return this.hasError === 'auth/wrong-password';
        },
        newPasswordError() {
            return this.hasError === 'auth/weak-password';
        },
        confirmPasswordError() {
            return (this.newPassword && this.confirmPassword) && (this.newPassword !== this.confirmPassword);
        }
    },
    created: function() {
        // const currentUser = firebase.auth().currentUser;
        // if (currentUser != null) {
        //     user.providerData.
        // }
    }
};
export default ChangePassword;
</script>

<style lang="scss">
form {
    width: 100%;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// change-password.vue?592a5675